import { ProFormaModelIds } from 'constants/proForma';

export const isApartmentModel = (proFormaModelId: ProFormaModelIds): boolean => (
    proFormaModelId === ProFormaModelIds.APARTMENT
);
export const isApartmentWithRetailModel = (proFormaModelId: ProFormaModelIds): boolean => proFormaModelId === ProFormaModelIds.APARTMENT_WITH_RETAIL;
export const isAllApartmentModels = (proFormaModelId: ProFormaModelIds): boolean => (
    [ProFormaModelIds.APARTMENT, ProFormaModelIds.APARTMENT_WITH_RETAIL].includes(proFormaModelId)
);
export const isModelWithLeasingCostReserves = (proFormaModelId: ProFormaModelIds): boolean => (
    [
        ProFormaModelIds.INDUSTRIAL,
        ProFormaModelIds.RETAIL,
        ProFormaModelIds.OFFICE,
        ProFormaModelIds.APARTMENT_WITH_RETAIL,
    ].includes(proFormaModelId)
);
export const isStudentHousingModel = (proFormaModelId: ProFormaModelIds): boolean => proFormaModelId === ProFormaModelIds.STUDENT_HOUSING;
